import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Authentication Context
import { AuthProvider } from './contexts/AuthContext';

// Components
import NavbarComponent from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';
import CategoryMenuBar from './components/CategoryMenuBar';

// Pages
import Home from './pages/Home';
import PostAd from './pages/PostAd';
import Profile from './pages/Profile';
import Favourites from './pages/Favourites';
import MyAds from './pages/MyAds';
import EditAd from './pages/EditAd';
import AdDetails from './pages/AdDetails';
import Chat from './pages/Chat';
import ChatList from './pages/ChatList';
import PhoneLogin from './pages/PhoneLogin';
import SearchResults from './pages/SearchResults';
import CategoryPage from './pages/CategoryPage';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DeleteAccount from './pages/DeleteAccount';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <CategoryMenuBar />
        <NavbarComponent />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<PhoneLogin />} />
          <Route path="/ad/:id" element={<AdDetails />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/category/:categoryId" element={<CategoryPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />

          {/* Protected Routes */}
          <Route 
            path="/chats" 
            element={
              <PrivateRoute>
                <ChatList />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/chat/:chatId" 
            element={
              <PrivateRoute>
                <Chat />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/post-ad" 
            element={
              <PrivateRoute>
                <PostAd />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/post-ad/:categoryId" 
            element={
              <PrivateRoute>
                <PostAd />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/favourites" 
            element={
              <PrivateRoute>
                <Favourites />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/my-ads" 
            element={
              <PrivateRoute>
                <MyAds />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/edit-ad/:id" 
            element={
              <PrivateRoute>
                <EditAd />
              </PrivateRoute>
            } 
          />
        </Routes>
        <ToastContainer />
      </div>
    </AuthProvider>
  );
}

export default App;